<h3 mat-dialog-title class="color-primary">{{ data.title }}</h3>

<div mat-dialog-content>
	<div class="form-group kt-form__group row">
		<div class="col-lg-12">
			{{data.description}}
		</div>
	</div>
	<div class="form-group kt-form__group row" style="overflow-y: auto;
			max-height: 50vh;" *ngIf="currentData !== undefined">
		<ng-container *ngIf="arraySize == 1">
			<div class="form-group kt-form__group row">
				<div class="col-lg-12">
					<xeditor-block [config]="editorConfig" [value]="currentData"
						[widget_Buttons_map]="widget_Buttons_map" (textView)="onChange($event)">
					</xeditor-block>
				</div>
			</div>
		</ng-container>
		<ng-container *ngIf="arraySize > 1">
			<div class="form-group kt-form__group row" *ngFor="let number of getNumberRange(arraySize)">
				<div class="col-lg-2">
					<span matPrefix>{{number - 1}}.</span>
				</div>
				<div class="col-lg-10">
					<xeditor-block [config]="editorConfig" [value]="currentData[number-1]"
						[widget_Buttons_map]="widget_Buttons_map" (textView)="onChange($event, number-1)">
					</xeditor-block>
				</div>
			</div>
		</ng-container>
	</div>
</div>
<div mat-dialog-actions align="end">
	<button mat-button (click)="onNoClick()" color="danger">{{data.cancelbtn}}</button>&nbsp;
	<button mat-flat-button (click)="onYesClick()" cdkFocusInitial>{{data.confirmbtn}}</button>
</div>